/** @jsx jsx */
import { css, jsx } from "@emotion/react"
import CartIcon from "../../assets/icons/cart.svg"
import React, { useEffect, useState, useContext } from "react"
const MaxQtyMeta = props => {
  const { address, status, itemInCartQty } = props

  // Guard against null status from API.
  const { ordered_last, max_qty, max_qty_ordered, max_qty_frequency, limit_type,
    over_limit, user_allocation, user_allocation_remaining } =
    status || {}
  const limitSuffix = limit_type === "per_user" ? " (user limit)" : ""
  const remaining = Math.max(0, (max_qty || 0) - (max_qty_ordered || 0))
  // Use personal allocation cap when present; fall back to segment remaining.
  // Math.min ensures we never exceed max_qty even when user_allocation_remaining is larger.
  const effectiveRemaining =
    user_allocation != null
      ? Math.max(0, Math.min(max_qty ?? Infinity, user_allocation_remaining ?? 0))
      : remaining

  const formatDate = d =>
    typeof d === "string"
      ? d.split("/")[1] + "/" + d.split("/")[0] + "/" + d.split("/")[2]
      : String(d.getDate()).padStart(2, "0") +
        "/" +
        String(d.getMonth() + 1).padStart(2, "0") +
        "/" +
        d.getFullYear()
  const diffDays = (date, otherDate) =>
    Math.ceil(Math.abs(date - otherDate) / (1000 * 60 * 60 * 24))
  const addMonths = (numOfMonths, date = new Date()) =>
    date.setMonth(date.getMonth() + numOfMonths)
  const addDays = (numOfDays, date = new Date()) =>
    date.setDate(date.getDate() + numOfDays)

  const [date, setDate] = useState(false)

  useEffect(async () => {
    if (ordered_last && ordered_last !== "") {
      var today = new Date()
      var dd = String(today.getDate()).padStart(2, "0")
      var mm = String(today.getMonth() + 1).padStart(2, "0") //January is 0!
      var yyyy = today.getFullYear()
      today = mm + "/" + dd + "/" + yyyy

      let orderLastDate = new Date(formatDate(ordered_last))

      let doMath = false
      switch (max_qty_frequency) {
        case "daily":
          doMath = addDays(1, orderLastDate)
          break
        case "weekly":
          doMath = addDays(7, orderLastDate)
          break
        case "monthly":
          doMath = addMonths(1, orderLastDate)
          break
        case "yearly":
          doMath = addMonths(12, orderLastDate)
          break
        default:
          break
      }

      if (doMath !== false) setDate(diffDays(doMath, new Date(today)))
    }
  }, [])

  return (
    <label
      htmlFor={`filter-stores-${address.address_id}`}
      className="flex flex-col cursor-pointer w-full"
    >
      {
        // <>
        //   <span className="text-reg-16 text-dark">{address.address_name}</span>
        //   <span
        //     htmlFor={`filter-stores-${address.address_id}`}
        //     className={`text-reg-14 max-w-[70%] !leading-6`}
        //   >
        //     {address.address}
        //   </span>
        // </>
      }
      {(max_qty != null || user_allocation != null) && (
        <>
          <div className="bg-[#f7f7f7] border border-[#EBEBEB] rounded-[8px] px-2 py-2 text-reg-12 !leading-[1.2] d-flex mr-auto mt-2">
            {over_limit === true && (
              <span className="text-[#c00] font-semibold block">
                Allocation limit reached{limitSuffix}.
              </span>
            )}
            {!over_limit && max_qty_frequency === "forever" && (
              <span>
                {effectiveRemaining <= 0
                  ? `You've reached your order limit for this asset${limitSuffix}. You can't order more units.`
                  : `You can still order ${effectiveRemaining} units of this asset${limitSuffix}.`}
              </span>
            )}
            {!over_limit && max_qty_frequency === "yearly" && (
              <span>
                {effectiveRemaining <= 0
                  ? `You've reached your order limit for this year${limitSuffix}.
                    ${
                      date !== false &&
                      `/ ${date} days until you can order again`
                    }`
                  : `You can still order ${effectiveRemaining} this year${limitSuffix}.`}
              </span>
            )}
            {!over_limit && max_qty_frequency === "monthly" && (
              <span>
                {effectiveRemaining <= 0
                  ? `You've reached your order limit for this month${limitSuffix}.
                    ${
                      date !== false &&
                      `/ ${date} days until you can order again`
                    }`
                  : `You can still order ${effectiveRemaining} this month${limitSuffix}.`}
              </span>
            )}
            {!over_limit && max_qty_frequency === "biweekly" && (
              <span>
                {effectiveRemaining <= 0
                  ? `You've reached your order limit for this fortnight${limitSuffix}.`
                  : `You can still order ${effectiveRemaining} during this two-week period${limitSuffix}.`}
              </span>
            )}
            {!over_limit && max_qty_frequency === "weekly" && (
              <span>
                {effectiveRemaining <= 0
                  ? `You've reached your order limit for this week${limitSuffix}.`
                  : `You can still order ${effectiveRemaining} this week${limitSuffix}.`}
              </span>
            )}
            {!over_limit && max_qty_frequency === "daily" && (
              <>
                <span>
                  {effectiveRemaining <= 0
                    ? `You've reached your order limit for today${limitSuffix}.`
                    : `You can still order ${effectiveRemaining} today${limitSuffix}.`}
                </span>
              </>
            )}
          </div>
          {itemInCartQty !== null && itemInCartQty !== false && (
            <span className="flex space-x-2 items-center mt-2">
              <CartIcon className="w-4 h-4" />
              <span className="text-reg-11 text-dark">
                {itemInCartQty} already in your cart. You can add{" "}
                {Math.max(0, effectiveRemaining - itemInCartQty)} more.
              </span>
            </span>
          )}
        </>
      )}
    </label>
  )
}
export default MaxQtyMeta
